/**
 * @generated SignedSource<<b7a2589ae40368beeb56fccd93966a99>>
 * @relayHash c5eb0cfd9373eea79957d11b09418980
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9d7a7335741148263b32cba82201410f4a6be5829e003845d67fea9f98d02335

import type { ConcreteRequest } from 'relay-runtime';
export type GetSpaceNameQuery$variables = {
  spaceKey: string;
};
export type GetSpaceNameQuery$data = {
  readonly space: {
    readonly id: string | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
};
export type GetSpaceNameQuery = {
  response: GetSpaceNameQuery$data;
  variables: GetSpaceNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GetSpaceNameQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetSpaceNameQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c5eb0cfd9373eea79957d11b09418980",
    "id": "9d7a7335741148263b32cba82201410f4a6be5829e003845d67fea9f98d02335",
    "metadata": {},
    "name": "GetSpaceNameQuery",
    "operationKind": "query",
    "text": "query GetSpaceNameQuery($spaceKey:String!){space(key:$spaceKey){id,name}}"
  }
};
})();

(node as any).hash = "af1524a43384ebea4777218a131343d7";

export default node;
